module.exports = __webpack_public_path__ + "img/bluebadge.803f8c28.svg";